export const buildUnauthenticatedRedirectUrl = (
  lmsRedirectUrl: string,
  currentUrl: string,
  redirectParamName = "inventRedirectUrl",
): string => {
  const encodedCurrentUrl = encodeURIComponent(currentUrl);
  const separator = lmsRedirectUrl.includes("?") ? "&" : "?";
  return `${lmsRedirectUrl}${separator}${redirectParamName}=${encodedCurrentUrl}`;
};
